/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ArrowLeftIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 17.3 17.3'
			width='1em'
			height='1em'
			{...props}
		>
			<path
				d='M16.6 7.7H2.7l6.1-6.1c.3-.3.3-.8 0-1.1S8 .2 7.7.5L.2 8.1c-.1.2-.2.4-.2.6s.1.4.2.5l7.6 7.6c.2.1.4.2.6.2s.4-.1.5-.2c.3-.3.3-.8 0-1.1L2.4 9.2h14.2c.4 0 .8-.3.8-.8s-.4-.7-.8-.7z'
				fill={color}
			/>
		</svg>
	)
}

export default ArrowLeftIcon
